export let dataProps = {
    id: 0,
    store_id: null, 
    customer_id: null,
    sale_id: 0,
    payment_date: new Date(),
    additional_notes: '',
    paid_amount: 0, 
    redeemed_amount: 0,
    advance_payment: false,
    payment_mode_id: null,
    gift_card_id: null,
    adjustment: 0,
    image_path: ''
}


// WEBPACK FOOTER //
// ./src/store/modules/customerPayment/properties.js